import Vue from 'vue'
import Vuex from 'vuex'
import valores from '@/store/modules/valores'
import snackbar from '@/store/modules/snackbar'
import loading from '@/store/modules/loading'
import cuenta from '@/store/modules/cuenta'
import prestamo from '@/store/modules/prestamo'
import plazoFijo from '@/store/modules/plazoFijo'
import facturaCredito from '@/store/modules/facturaCredito'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    loading,
    snackbar,
    valores,
    cuenta,
    prestamo,
    plazoFijo,
    facturaCredito,
  },
  strict: debug
})
